import { tr } from 'date-fns/locale';
const dateTrTR = {
  name: 'tr-TR',
  locale: tr
};
export default dateTrTR;